import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.scss']
})
export class PrivacyPolicyComponent implements OnInit {
  IsOptimoney: boolean;
  Company_Name = "";
  Company_Address = "";
  Domain = "";
  Company_Email = "";
  constructor(public sanitizer: DomSanitizer) { }

  ngOnInit() {
    this.Domain = sessionStorage.getItem('ihjt45h45=Domain_Url')
    this.Company_Name = sessionStorage.getItem('ihjt45h45=CompanyName')
    this.Company_Email = sessionStorage.getItem('ihjt45h45=jmail')
    this.Company_Address = sessionStorage.getItem('ihjt45h45=n')
  }
}
